exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vanilla-slider {\n  border-radius: 0.3em;\n  background-color: #f6f6f6; }\n  .vanilla-slider__range {\n    border-radius: 0.3em;\n    background-color: #ed5565; }\n  .vanilla-slider_horizontal {\n    height: 0.6em; }\n    .vanilla-slider_horizontal .vanilla-slider__range {\n      height: 100%; }\n  .vanilla-slider_vertical {\n    width: 0.6em; }\n    .vanilla-slider_vertical .vanilla-slider__range {\n      width: 100%; }\n  .vanilla-slider__handle {\n    width: 1.2em;\n    height: 1.2em;\n    outline: none;\n    border: 1px solid #ed5565;\n    border-radius: 0.3em;\n    background-color: #f6f6f6;\n    cursor: pointer; }\n    .vanilla-slider__handle:hover {\n      border-color: #c71528; }\n    .vanilla-slider__handle:focus {\n      border-color: #c71528;\n      box-shadow: 0 0 2px 0 blue; }\n    .vanilla-slider__handle_active {\n      background-color: #c3c3c3; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?importLoaders=2!../node_modules/sass-loader/lib/loader.js!./components/view/theme.scss
// module id = ../node_modules/css-loader/index.js?importLoaders=2!../node_modules/sass-loader/lib/loader.js!./components/view/theme.scss
// module chunks = 0